import React, { Component } from 'react';
import {
  Jumbotron,
  Container,
  Row,
  Input,
  Button,
  Alert,
} from 'reactstrap';
import { withApollo } from 'react-apollo';
import DateTimePicker from 'react-datetime-picker';
import { SEND_IMAGE_TO_LOVEPIX } from '../../mutation/mutation';

export default withApollo(class LovepixPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      loading: false,
      macAddress: localStorage.getItem('lovepixMacAddress') || '',
      frames: [],
      isPhoto: true,
      success: false,
      date: undefined,
    };
    this.onMacAddressChanges = this.onMacAddressChanges.bind(this);
    this.onIsPhotoChange = this.onIsPhotoChange.bind(this);
    this.onImagesUpload = this.onImagesUpload.bind(this);
    this.sendImage = this.sendImage.bind(this);
    this.onDateChanges = this.onDateChanges.bind(this);
  }

  onDateChanges(newDate) {
    this.setState({ date: newDate });
  }

  onMacAddressChanges({ target: { value: newMacAddress } }) {
    this.setState({ macAddress: newMacAddress.toUpperCase() });
  }

  onIsPhotoChange() {
    const { isPhoto } = this.state;
    this.setState({ isPhoto: !isPhoto });
  }

  onImagesUpload({ target: { files } }) {
    const { frames } = this.state;
    if (!files[0]) {
      return;
    }
    const readFile = (file, index) => {
      const reader = new FileReader();
      const image = new Image();
      image.onload = () => {
        frames[index] = reader.result;
        this.setState({ frames });
      };
      reader.onloadend = () => {
        image.src = reader.result;
      };
      reader.onerror = (error) => {
        this.setState({ error });
      };
      reader.readAsDataURL(file);
    };
    for (let i = 0; i < files.length; i += 1) {
      readFile(files[i], i);
    }
  }

  sendImage() {
    const {
      loading,
      macAddress,
      frames,
      isPhoto,
      date,
    } = this.state;
    const { client: { mutate } } = this.props;
    if (loading) {
      return;
    }
    this.setState({ loading: true });
    localStorage.setItem('lovepixMacAddress', macAddress);
    mutate({
      mutation: SEND_IMAGE_TO_LOVEPIX,
      variables: {
        macAddress,
        frames,
        isPhoto,
        date,
      },
    }).then((data) => {
      console.log(data);
      this.setState({ success: true });
      setTimeout(() => this.setState({ success: false }), 3000);
    }).catch((error) => {
      this.setState({ error });
    }).finally(() => this.setState({ loading: false }));
  }

  render() {
    const {
      loading,
      error,
      success,
      macAddress,
      frames,
      isPhoto,
      date,
    } = this.state;
    return (
      <Jumbotron>
        <h3 className="display-4">
          Lovepix
        </h3>
        <hr className="my-2" />
        <h4>Send image</h4>
        <Container>
          <Row>
            <span>MAC Address (without the ":")</span>
          </Row>
          <Row>
            <Input
              type="text"
              value={macAddress}
              onChange={this.onMacAddressChanges}
              style={{ width: '320px' }}
            />

            <DateTimePicker
              onChange={this.onDateChanges}
              value={date}
            />

          </Row>
          <Row>
            <span>Images (3 frames max)</span>
            <Input
              accept="image/*"
              multiple
              onChange={this.onImagesUpload}
              type="file"
            />
          </Row>
          <Row>
            <img src={frames[0]} style={{ height: '240px', width: '320px', marginRight: '10px' }} alt="1" />
            <img src={frames[1]} style={{ height: '240px', width: '320px', marginRight: '10px' }} alt="2" />
            <img src={frames[2]} style={{ height: '240px', width: '320px', marginRight: '10px' }} alt="3" />
          </Row>
          <Row style={{ alignItems: 'center' }}>
            Anti-aliasing (uncheck only if you know what you're doing)
            <input
              name="isPhoto"
              type="checkbox"
              checked={isPhoto}
              onChange={this.onIsPhotoChange}
            />
          </Row>
          <Row>
            <Button
              disabled={macAddress.length !== 12 || !(frames || []).length || loading}
              type="submit"
              color="success"
              onClick={this.sendImage}
              style={{ marginTop: '20px', width: '320px', height: '50px' }}
            >
              Send
            </Button>
          </Row>
          {
            success && (
              <Alert color="success">
                Image sent!
              </Alert>
            )
          }
          {
            error && (
              <Alert color="danger">
                {`${error}`}
              </Alert>
            )
          }
        </Container>
      </Jumbotron>
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/lovepix/lovepix.js